module.exports = __webpack_public_path__ + "media/images/sindma/icon-ultimasleyes-f4495bb56091509e1f55ed62a7b0aca7.png";